import { useState, useEffect } from 'react';

export function useEditableTable<T>(initialData: T[]) {
  const [editableProperties, setEditableProperties] = useState<T[]>(initialData);

  useEffect(() => {
    setEditableProperties(initialData);
  }, [initialData]);

  return {
    editableProperties,
    setEditableProperties,
  };
}